import type { AxiosResponse } from 'axios'
import type {
  DestinationDetailList,
  QueryDestinationDetailListModel,
  QueryOtherCompanyProductListByUserModel,
  QuerySendCartResponse,
  RecipientOptionList,
  RegistSendCartDestinationParameters,
} from './model/sendCartModel'
import type { FolderList } from '../model/folderModel'

import { bffHTTP } from '@/utils/http/axios'
import { handleAPIException } from '@/utils/exception'
import { SendCartTypeEnum } from './model/sendCartModel'
import { ApiResponseStatusEnum, HTTPMethodsEnum } from '@/enums'

export async function getCarts(
  sendCartType?: SendCartTypeEnum
): Promise<QuerySendCartResponse | undefined> {
  try {
    const response: AxiosResponse<QuerySendCartResponse, null> = await bffHTTP({
      method: HTTPMethodsEnum.GET,
      url: `/carts/${sendCartType ?? SendCartTypeEnum.NORMAL}`,
    })

    handleAPIException(response)

    if (response.status !== ApiResponseStatusEnum.SUCCESSFUL_STATUS) {
      return
    }

    return response.data
  } catch (error) {
    console.log('getCarts', error)
  }
}

export async function getCartsCount(): Promise<any | undefined> {
  try {
    const response: AxiosResponse<any, any> = await bffHTTP({
      method: 'get',
      url: '/carts/1/count',
    })
    handleAPIException(response)
    return response.data.detail
  } catch (error) {}
}

/**
 * @description: 送信カートファイル削除
 * @returns
 */
export async function deleteCarts(type: SendCartTypeEnum): Promise<any | undefined> {
  try {
    const response: AxiosResponse<any, any> = await bffHTTP({
      method: 'delete',
      url: `/carts/${type}`,
    })

    handleAPIException(response)
    return response.data.detail.count
  } catch (error) {
    console.warn('deleteCarts', error)
  }
}

/**
 * @description: 送信カート送信先削除
 * @returns
 */
export async function deleteCartRecipients(
  type?: SendCartTypeEnum
): Promise<any | undefined> {
  try {
    const response: AxiosResponse<any, any> = await bffHTTP({
      method: 'delete',
      url: `/cart_recipients/${type ?? SendCartTypeEnum.NORMAL}`,
    })

    handleAPIException(response)

    return response.status
  } catch (error) {
    console.log('getCarts', error)
  }
}

//送信カートへ追加
export async function postSendCartAdd(data: any): Promise<any | undefined> {
  try {
    const response: AxiosResponse<any, any> = await bffHTTP({
      method: 'POST',
      url: '/carts',
      data,
    })

    handleAPIException(response)

    if (response.status === 200) {
      return response.data.detail.count
    } else {
      return response.data.detail.message
    }
  } catch (error) {
    console.log('postSendCartAdd error')
  }
}

/**
 * @descripiton 送信先マスタ一覧
 * @returns
 */
export async function getRecipientOptions(): Promise<RecipientOptionList> {
  try {
    const response: AxiosResponse<{ detail: RecipientOptionList }, any> = await bffHTTP({
      method: 'GET',
      url: '/recipients',
    })

    handleAPIException(response)
    return response.data.detail
  } catch (error) {
    console.log('getRecipientOptions error', error)
    return []
  }
}

// 送信API
export async function transactions(): Promise<any | undefined> {
  try {
    const response: AxiosResponse<any, any> = await bffHTTP({
      method: 'POST',
      url: '/trust/transactions',
    })

    handleAPIException(response)
    return response.data
  } catch (error) {
    console.log('transaction_status', error)
  }
}

/**
 * @description 送信先詳細一覧取得 API
 * @param destinationID 送信先 ID
 * @returns 送信先詳細一覧
 */
export async function queryDestinationDetailList(
  destinationID: string | number
): Promise<DestinationDetailList> {
  try {
    const response: AxiosResponse<QueryDestinationDetailListModel, any> = await bffHTTP({
      method: 'GET',
      url: `/recipient_details/${destinationID.toString()}`,
    })

    handleAPIException(response)
    return response.data.detail
  } catch (error) {
    console.log('queryDestinationDetailList', error)
    return []
  }
}

/**
 * @description 他社フォルダと送信先取得 API
 * @param corporateNumber 送信先法人番号
 * @returns 送信先フォルダ一覧
 */
export async function queryDestinationFolderTree(
  corporateNumber: number
): Promise<FolderList> {
  try {
    const response: AxiosResponse<QueryOtherCompanyProductListByUserModel, any> =
      await bffHTTP({
        method: 'GET',
        url: '/folders/other',
        params: { recipient_corporate_number: corporateNumber },
      })

    handleAPIException(response)
    return response.data.detail
  } catch (error) {
    console.log('queryDestinationFolderTree', error)
    return []
  }
}

/**
 * @description 送信カート宛先登録 API
 * @param parameters
 * @returns
 */
export async function registSendCartDestination(
  parameters: RegistSendCartDestinationParameters
): Promise<boolean> {
  try {
    const response: AxiosResponse<any, any> = await bffHTTP({
      url: 'cart_recipients',
      method: 'POST',
      data: parameters,
    })

    handleAPIException<any>(response)
    return true
  } catch (error) {
    console.log('registSendCartDestination', error)
    return false
  }
}
